import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './components/App'
import { state } from './state'

export const rerender = () =>
  ReactDOM.render(<App {...state} />, document.getElementById('reactRoot'))
